export function createBotWorker() {
  return new Worker(new URL('./bot.worker.js', import.meta.url));
}
